import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;
export const RitualIcon = (props: Props) => {
	return (
		<svg version="1.1" viewBox="0 0 12.2 14.8" {...props}>
			<defs>
				<style>{`.black {fill: var(--color-neutral-foreground-1);} .white {fill: var(--color-neutral-background-3);}`}</style>
			</defs>
			<path
				className="black"
				d="M3,0H1.2C0.5,0,0,0.6,0,1.2c0,0,0,0,0,0v12.4c0,0.7,0.5,1.2,1.2,1.2c0,0,0,0,0,0h10.2c0.4,0,0.8-0.3,0.8-0.8
			c0-0.4-0.3-1-0.8-1H2.1c-0.3,0-0.6,0-0.6-0.3s0.3-1,0.6-1H11c0.7,0,1.2-0.6,1.2-1.2c0,0,0,0,0,0V1.2C12.2,0.6,11.7,0,11,0
			c0,0,0,0,0,0H3"
			/>
			<g>
				<path
					className="white"
					d="M5.6,6.5v2.6H4.3V2C5.3,2,5.8,2,5.8,2c1.1,0,1.9,0.2,2.5,0.5c0.5,0.3,0.8,0.9,0.8,1.6c0,1.6-1,2.5-2.9,2.5
				C6,6.6,5.8,6.5,5.6,6.5z M5.6,3.1v2.3c0.2,0,0.4,0,0.5,0c0.6,0,1-0.1,1.3-0.3c0.3-0.2,0.4-0.5,0.4-0.9c0-0.7-0.6-1.1-1.8-1.1
				C5.8,3.1,5.7,3.1,5.6,3.1z"
				/>
			</g>
		</svg>
	);
};

export const ConcentrationIcon = (props: Props) => {
	return (
		<svg version="1.1" viewBox="0 0 20.2 20.2" {...props}>
			<defs>
				<style>{`.black {fill: var(--color-neutral-foreground-1);} .white {fill: var(--color-neutral-background-3);}`}</style>
			</defs>
			<rect
				x="2.9"
				y="3"
				transform="matrix(0.7071 -0.7071 0.7071 0.7071 -4.1817 10.0846)"
				className="black"
				width="14.3"
				height="14.3"
			/>
			<path
				className="white"
				d="M13,13.3c-0.1,0-0.2,0-0.4,0c-0.4,0-0.8-0.1-1-0.3s-0.4-0.6-0.5-1.1c-0.1-0.7-0.3-1.2-0.7-1.5S9.7,10,9.1,10
		H9.1v3.2H7.8V6.1h1.3v2.8h0.1c0.6,0,1-0.1,1.3-0.4s0.5-0.6,0.6-1.2c0.1-0.5,0.2-0.8,0.4-1S12,6,12.5,6c0.2,0,0.3,0,0.4,0v1.1
		c0,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.2-0.2,0.5c-0.1,0.4-0.3,0.8-0.6,1.1S11,9.3,10.6,9.4
		c0.5,0.1,0.8,0.4,1.1,0.7s0.5,0.8,0.6,1.4c0.1,0.3,0.1,0.5,0.2,0.5c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0V13.3z"
			/>
		</svg>
	);
};

export const AttunementIcon = (props: Props) => {
	return (
		<svg version="1.1" viewBox="0 0 20 18" {...props}>
			<defs>
				<style>{`.black {fill: var(--color-neutral-foreground-1);} .white {fill: var(--color-neutral-background-3);}`}</style>
			</defs>
			<path className="black" d="M10,0.5L19.6,17.5H0.4Z" />
			<path className="white" d="M7,8h1.5v2.9h3V8H13v8h-1.5v-3.8h-3V16H7Z" />
		</svg>
	);
};
